<template>
  <div
    class="BibtexView w-full h-full flex justify-center items-center flex-col relative bottom-10"
  >
    <div class="text-3xl font-bold p-5">BibTeX</div>
    <div class="Code w-6/12">
      <div class="content text-gray-500 text-base">
        @misc{sun2024pathmmumassivemultimodalexpertlevel, <br />
        &nbsp; &nbsp; &nbsp; &nbsp;title={PathMMU: A Massive Multimodal
        Expert-Level Benchmark for Understanding and Reasoning in Pathology},<br />
        &nbsp; &nbsp; &nbsp; &nbsp;author={Yuxuan Sun and Hao Wu and Chenglu Zhu
        and Sunyi Zheng and Qizi Chen and Kai Zhang and Yunlong Zhang and Dan
        Wan and Xiaoxiao Lan and Mengyue Zheng and Jingxiong Li and Xinheng Lyu
        and Tao Lin and Lin Yang}, <br />
        &nbsp; &nbsp; &nbsp; &nbsp;year={2024},<br />
        &nbsp; &nbsp; &nbsp; &nbsp;eprint={2401.16355}, <br />
        &nbsp; &nbsp; &nbsp; &nbsp;archivePrefix={arXiv}, <br />
        &nbsp; &nbsp; &nbsp; &nbsp;primaryClass={cs.CV}, <br />
        &nbsp; &nbsp; &nbsp; &nbsp;url={https://arxiv.org/abs/2401.16355}<br />
        &nbsp;&nbsp;}
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.Code {
  overflow-x: auto;
  padding: 1.5em 1.7em;
  white-space: pre;
  word-wrap: normal;
  background-color: #f5f5f5;
}
.Code .content {
  background-color: transparent;
  /* color: currentColor; */
  padding: 0;
}
</style>
